import React, { useState, useEffect } from "react";
import WrapperContainer from "./utilities/WrapperContainer";
import FloatingMessage from "./utilities/FloatingMessage";
import useResponsiveFlags from "../hooks/useResponsiveFlags";
import AgreementViewer from "./AgreementView";
import TokenStatus from "./TokenStatus";
import AgreementFormDialog from "./AgreementFormDialog";
import FocusedView from "./FocusedView";
import ViewStatusTimeline from "./AgreementStatusTimeline";
import axios from "../api/axios";

export default function Tokens() {
  const { isDesktop } = useResponsiveFlags();
  const [dataLoading, setDataLoading] = useState(false);
  const [error, setError] = useState("");
  const [selectedAgreementForCreation, setSelectedAgreementForCreation] = useState("");
  const [showAgreementGenerationForm, setShowAgreementGenerationForm] = useState(false);
  const [agreementGenerationLoading, setAgreementGenerationLoading] = useState(false);
  const [agreementDataLoading, setAgreementDataLoading] = useState(false);
  const [activeType, setActiveType] = useState("getToken");
  const [agreementViewerOpen, setAgreeementViewerOpen] = useState(false);
  const [viewAgreementData, setViewAgreementData] = useState({});
  const [agreementText, setAgreementText] = useState("");
  const [fetchAgreementError, setFetchAgreementError] = useState(false);
  const [showFocusedSigning, setShowFocusedSigning] = useState(false);
  const [envelopeFocusedUrl, setEnvelopeFocusedUrl] = useState("");
  const [showCheckAgreementCarousel,setShowCheckAgreeementCarousel] =useState(false);
  const [checkAgreementStatusInput,setCheckAgreementStatusInput] =useState("");
  
  const [agreements, setAgreements] = useState({
    envelopeFracFree: null,
    envelopeFracSample: null,
    pdfFracFree: null,
    pdfFracSample: null,
    envelopeHiresFree: null,
    envelopeHiresSample: null,
    pdfHiresFree: null,
    pdfHiresSample: null,
  });

  useEffect(() => {
    getAgreementData();
  }, []);

  const handleCloseAgreementGenerationForm = () => {
    setShowAgreementGenerationForm(false);
  }
  const agreementGeneration = async (data) => {
    handleCloseAgreementGenerationForm();
    setAgreementGenerationLoading(true);
    setError("");
    const requestData = {
      ...data,
      type: selectedAgreementForCreation
    }
    axios.post('/api/create-envelope', { ...requestData }).then((res) => {
      if (res.data?.success) {
        if (data.emailCheck) {
          setDataLoading(true);
          setTimeout(() => {
            fetchCheckAgreementStatus(res.data.envelopeId);
          }, 4000);
        } else {
          fetchFocusedSigningURL(res.data.envelopeId);
        }
        getAgreementData();
      } else {
        if (res.data?.status) {
          handleDocuSignGenerationErrorResponse(res.data);
        } else if (res.data.message) {
          setError(res.data.message);
        } else {
          setError("Faied to create the agreement for signing.");
        }
      }
      setAgreementGenerationLoading(false);

    }).catch((res) => {
      setError("Faied to create the agreement for signing.");
      setAgreementGenerationLoading(false);
    })
  }
  const fetchFocusedSigningURL = async (envelopeId) => {
    setDataLoading(true);
    setError("");
    axios.post(
      "/api/fetch-focused-signing-url",
      { envelope_id: envelopeId }
    ).then((res) => {
      if (res.data?.success) {
        setEnvelopeFocusedUrl({'url': res.data.focusedUrl, 'envelopeId': envelopeId});
        setShowFocusedSigning(true);
      } else {
        if (res.data?.status) {
          handleDocuSignGenerationErrorResponse(res.data);
        } else if (res.data.message) {
          setError(res.data.message);
        } else {
          setError("Faied to open the In app docusign signing.");
        }
      }
      setDataLoading(false);
    }).catch((res) => {
      setError("Faied to open the In app docusign signing.");
      setDataLoading(false);
    })
  };

  const fetchCheckAgreementStatus = async (envelopeId) => {
    setDataLoading(true);
    setError("");
    setCheckAgreementStatusInput("");
    axios.post(
      "/api/fetch-check-agreement-status",
      { envelope_id: envelopeId }
    ).then((res) => {
      if (res.data?.success) {
        setCheckAgreementStatusInput(res.data);
        setShowCheckAgreeementCarousel(true);
      } else {
        if (res.data?.status) {
          handleDocuSignGenerationErrorResponse(res.data);
        } else if (res.data.message) {
          setError(res.data.message);
        } else {
          setError("Faied to fetch the agreement Status.");
        }
      }
      setDataLoading(false);
    }).catch((res) => {
      setError("Faied to fetch agreement status.");
      setDataLoading(false);
    })
  };

  const getAgreementData = async () => {
    setAgreementDataLoading(true);
    setError("");
    try {
      const response = await axios.get("/api/get-agreements-info");
      if (response.data) {
        setAgreements(response.data);
      } else {
        setError("Invalid agreement data received.");
        setFetchAgreementError(true);
      }
    } catch (error) {
      setError("Failed to load the agreements info.");
      setFetchAgreementError(true);
    }
    setAgreementDataLoading(false);
  };

  const handleDocuSignGenerationErrorResponse = (data) => {
    if (data.status === "Failed") {
      setError(data.message);
      return;
    }

    if (data.status === "AuthRequired") {
      if (data.authorization_url) {
        window.location.href = data.authorization_url;
      } else {
        setError(data.message);
      }
    }

  }
  const fetchAgreement = async (agreement_id, type) => {
    setDataLoading(true);
    setError("");
    axios.post('/api/view-agreement-pdf', {
      'id': agreement_id,
      'type': type,
    }).then((res) => {
      if (res.data?.success) {
        setViewAgreementData({
          pdfBase64: res.data.pdfBase64,
          generatedText: res.data.generatedText,
          orgName: res.data.orgName,
          agreementType: res.data.agreementType,
        });
        setAgreeementViewerOpen(true);
      } else {
        if (res.data?.status) {
          handleDocuSignGenerationErrorResponse(res.data);
        } else if (res.data.message) {
          setError(res.data.message);
        } else {
          setError("Faied to fetch agreement PDF");
        }
      }
      setDataLoading(false);
    }).catch((res) => {
      setError("Faied to fetch agreement PDF");
      setDataLoading(false);
    })
  }
  const fetchAgreementText = async (agreement) => {
    setDataLoading(true);
    setError("");
    axios.post('/api/get-agreeement-text', {
      'agreement': agreement,
    }).then((res) => {
      if (res.data?.success) {
        setAgreementText(res.data.html);
        setShowAgreementGenerationForm(true);
      } else {
        if (res.data.message) {
          setError(res.data.message);
        } else {
          setError("Faied to fetch agreement.");
        }
      }
      setDataLoading(false);
    }).catch((res) => {
      setError("Faied to fetch agreement.");
      setDataLoading(false);
    })
  }
  //in progress
  const handleAgreementClick = async (agreement, pdf, envelope) => {
    if (pdf) {
      await fetchAgreement(pdf.agreement_id, "pdf");
    } else if (envelope) {
      if (envelope.can_view_pdf) {
        await fetchAgreement(envelope.envelope_id, "envelope");
      } else if (envelope.can_resume) {
        await fetchFocusedSigningURL(envelope.envelope_id);
      } else if (envelope.can_view_status) {
        fetchCheckAgreementStatus(envelope.envelope_id);
      }
    } else {
      setSelectedAgreementForCreation(agreement);
      fetchAgreementText(agreement);
    }
  };
  const handleTypeClick = (type) => {
    setActiveType(type);
  };
  const getLinkText = (pdf, envelope) => {
    if (pdf) {
      return "View Agreement PDF";
    }
    if (envelope) {
      if (envelope.can_view_pdf) return "View Agreement PDF";
      if (envelope.can_resume) return "Resume Signing";
      if (envelope.can_view_status) return "Check Agreement Status";
    } else {
      return "View and Sign Agreement";
    }
  };

  const tokenSections = [
    {
      title: "iSort™ Fractions",
      options: [
        {
          agreement: "Fractions_FreeTrialAgreement",
          type: "Free trial token",
          details:
            "One free token per organization\nUp to 15 samples for 30 days",
          link: getLinkText(
            agreements.pdfFracFree,
            agreements.envelopeFracFree
          ),
          pdf: agreements.pdfFracFree,
          envelope: agreements.envelopeFracFree,
        },
        {
          agreement: "Fractions_PerSampleToken_Agreement",
          type: "Per-sample token",
          details:
            "$50/sample\nContact info@cibermed.com for volume discount (50 or more samples per order)",
          link: getLinkText(
            agreements.pdfFracSample,
            agreements.envelopeFracSample
          ),
          pdf: agreements.pdfFracSample,
          envelope: agreements.envelopeFracSample,
        },
        {
          agreement: "",
          type: "Annual per-seat token",
          details:
            "Contact info@cibermed.com for volume discount (>300 samples/year)",
          link: null,
        },
      ],
    },
    {
      title: "iSort™ HiRes",
      options: [
        {
          agreement: "HiRes_FreeTrialAgreement",
          type: "Free Trial Token",
          details:
            "One free token per organization\nUp to 50 samples for 60 days",
          link: getLinkText(
            agreements.pdfHiresFree,
            agreements.envelopeHiresFree
          ),
          pdf: agreements.pdfHiresFree,
          envelope: agreements.envelopeHiresFree,
        },
        {
          agreement: "HiRes_PerSampleToken_Agreement",
          type: "Per-sample token",
          details:
            "$100/sample\nContact info@cibermed.com for volume discount (50 or more samples per order)",
          link: getLinkText(
            agreements.pdfHiresSample,
            agreements.envelopeHiresSample
          ),
          pdf: agreements.pdfHiresSample,
          envelope: agreements.envelopeHiresSample,
        },
        {
          agreement: "",
          type: "Annual per-seat token",
          details:
            "Contact info@cibermed.com for volume discount (>300 samples/year)",
          link: null,
        },
      ],
    },
  ];
  const handleDownload = async () => {
    setError("");
    axios.post('/api/download-agreement', {
      'agreement': selectedAgreementForCreation
    }).then((res) => {
      if (res.data?.success) {
        makeDownload(res.data.pdf);
      } else {
        if (res.data.message) {
          setError(res.data.message);
        } else {
          setError("Faied to download the agreement.");
        }
      }
    }).catch((res) => {
      setError("Faied to download the agreement.");
    })
  }
  const makeDownload = (pdfBase64) => {
    if (!pdfBase64) return;
    const fileName = `iSort_${selectedAgreementForCreation}.pdf`;
    const link = document.createElement("a");
    link.href = `data:application/pdf;base64,${pdfBase64}`;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <>
      {error && (
        <FloatingMessage
          message={error}
          onClose={() => setError(null)}
          isError={true}
          top={isDesktop ? "20px" : ""}
        />
      )}
      {agreementGenerationLoading && <ShowLoading type="text" />}
      {dataLoading && <ShowLoading />}
      {showAgreementGenerationForm && (
        <AgreementFormDialog
          show={showAgreementGenerationForm}
          onClose={handleCloseAgreementGenerationForm}
          agreementText={agreementText}
          handleDownload={handleDownload}
          agreementGeneration={agreementGeneration}
        />
      )}
      <AgreementViewer
        open={agreementViewerOpen}
        onClose={() => { setAgreeementViewerOpen(false); setViewAgreementData({}) }}
        pdfBase64={viewAgreementData?.pdfBase64}
        generatedText={viewAgreementData?.generatedText}
        orgName={viewAgreementData?.orgName}
        agreementType={viewAgreementData?.agreementType}
      />
      {showFocusedSigning && (
        <FocusedView
        show={showFocusedSigning}
        envelopeUrl={envelopeFocusedUrl?.url}
        envelopeId={envelopeFocusedUrl?.envelopeId}
        fetchAgreement={(envelopeId,type)=>{
          const run = async () => {
            await getAgreementData();
            fetchAgreement(envelopeId, type);
          };
          run();
        }}
        onClose={() => setShowFocusedSigning(false)}
      />)}
      <ViewStatusTimeline isOpen={showCheckAgreementCarousel} onClose={()=>{setShowCheckAgreeementCarousel(false); setCheckAgreementStatusInput("");}} fetchAgreement={(envelopeId,type)=>{
          const run = async () => {
            await getAgreementData();
            fetchAgreement(envelopeId, type);
          };
          run();
        }}
        input={checkAgreementStatusInput}/>
      <WrapperContainer
        title="Tokens"
        loggedin={true}
        buttons={
          <>
            <div className="buttons" data-toggle="buttons-radio">
              <button
                className={`menu-options px-4 ${activeType === "getToken" ? "btn-active" : "btn"
                  }`}
                onClick={() => handleTypeClick("getToken")}
              >
                <span>Get Token</span>
              </button>
              <button
                className={`menu-options px-4 ${activeType === "tokenStatus" ? "btn-active" : "btn"
                  }`}
                onClick={() => handleTypeClick("tokenStatus")}
              >
                <span>Token Status</span>
              </button>
            </div>
            <div className="dropdown dropdown-buttons">
              <button
                className="btn dropdown-toggle"
                type="button"
                id="optionsMenu"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                {activeType === "getToken" ? "Get Token" : "Token Status"}
              </button>
              <ul
                className="dropdown-menu dropdown-menu-end"
                aria-labelledby="optionsMenu"
              >
                <li>
                  <a
                    className="dropdown-item"
                    href="#"
                    onClick={() => handleTypeClick("getToken")}
                  >
                    Get Token
                  </a>
                </li>
                <li>
                  <a
                    className="dropdown-item"
                    href="#"
                    onClick={() => handleTypeClick("tokenStatus")}
                  >
                    Token Status
                  </a>
                </li>
              </ul>
            </div>
          </>
        }
        content={
          <>
            {activeType === "getToken" && (
              <>
                <p className="custom-title">Get a Token</p>
                <div className="dark-grey-text">
                  <p className="token-para">
                    Select a token type to review the associated terms and
                    conditions. Once the agreementis signed, a token
                    will be issued and you will receive an email notification.
                  </p>
                  <ul>
                    <li>
                      A token is required to run iSort&trade; on the browser
                      or locally.
                    </li>
                    <li>
                      Each token is uniquely tied to your account and
                      organization.
                    </li>
                    <li>
                      Each unique token can be run on both browser and locally.
                    </li>
                  </ul>
                  {/* )} */}
                </div>

                {tokenSections.map((section, index) => (
                  <div key={index} className="my-4">
                    <p
                      className="custom-title"
                      style={{ marginBottom: "-1px" }}
                    >
                      {section.title}
                    </p>
                    <div className="row">
                      {section.options.map((option, idx) => (
                        <div
                          className="col-12 col-xl-4"
                          key={idx}
                          style={{
                            margin: "10px 0",
                          }}
                        >
                          <div className="card d-flex flex-column run-locally-cards">
                            <div className="card-body">
                              <p className="token-card-title">
                                {option.type}
                              </p>
                              <p
                                className="dark-grey-text"
                                style={{ whiteSpace: "pre-line" }}
                              >
                                {option.details}
                              </p>
                            </div>
                            {option.link && (
                              <p
                                className="px-3 storage-limit"
                                style={{
                                  color: (agreementDataLoading || fetchAgreementError) ? "#999" : "#0061BB",
                                  cursor: (agreementDataLoading || fetchAgreementError) ? "not-allowed" : "pointer",
                                }}
                                onClick={() => {
                                  if (!(agreementDataLoading || fetchAgreementError)) {
                                    handleAgreementClick(option.agreement, option.pdf, option.envelope);
                                  }
                                }}
                                aria-disabled={agreementDataLoading || fetchAgreementError}
                              >
                                {agreementDataLoading ? "Loading..." : fetchAgreementError ? "Failed to fetch agreement info." : `${option.link} →`}
                              </p>
                            )}
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                ))}

              </>
            )}
            {activeType === "tokenStatus" && (
              <>
                <TokenStatus />
              </>
            )}
          </>
        }
      />
    </>
  );
}

function ShowLoading({ type = "" }) {
  return (<div
    id="loading-overlay"
    style={{
      position: "fixed",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      backgroundColor: "rgba(0, 0, 0, 0.8)",
      zIndex: 9999,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    }}
  >{type == 'text' ?
    (<h3
      style={{
        color: "white",
        textAlign: "center",
      }}
    >
      It might take around 1-2 minutes to generate your agreement. Please
      do not close this tab or click anywhere.
    </h3>) : <img src="./loading.gif" alt="Loading..." style={{ minWidth: "100px", width: "6vw" }} />
    }
  </div>);
}